import React, { useState } from 'react';
import Button from '../components/Button';
import Chip from '../components/Chip';
import Input from '../components/Input';
import Snackbar from '../components/Snackbar';
import { SaveVendorStetmment } from '../api/Functions/rozliczenieVendors';
export default function VendorLicenseStatment({
  v,
  allSettled,
  isCurrentMonth,
  openSettleForVendor,
  onSave
}) {
   const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });
    const [approved, setApproved] = useState(Boolean(v.approved)|| Boolean(0));
const getMonthRange = (dateString) => {
  const [datePart] = dateString.split(' ');
  const [year, month] = datePart.split('-').map(Number);
  const start = new Date(year, month - 1, 1, 0, 0, 0);
  const end = new Date(year, month, 0, 23, 59, 59);

  // Ręczne formatowanie do "YYYY-MM-DD HH:mm:ss"
  const pad = (num) => String(num).padStart(2, '0');
  const formatDate = (d) =>
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;

  return {
    start: formatDate(start),
    end: formatDate(end), 
  };
};

const { start: date_from, end: date_to } = getMonthRange(v.renewal_date);

const [marketingCost, setMarketingCost] = useState(
  approved
    ? Number(v.marketing_value || 0) // jeśli zatwierdzone, użyj marketing_value
    : Number(v.marketing || 0)       // jeśli niezatwierdzone, użyj marketing
);  const [invoiceNumber, setInvoiceNumber] = useState(v.invoiceNumber || '');
  const [saving, setSaving] = useState(false);

  //console.log("Marketing Cost: " + v.invoiceNumber);
  //console.log("Approved: " + approved);
  //console.log("Invoice Number: " + invoiceNumber);

  const handleSave = async () => {
    setSaving(true);
    try {
    const payload = {
  vendor_id: v.companyId,             // ID dostawcy
  approved: 1,                         // przy zatwierdzeniu
  marketing_value: Number(marketingCost),
  provision_value: Number(v.ProwizjaDlaVendora),                  // lub wartość wyliczona
  fv_number_value: invoiceNumber || "BRAK",
  date_from: date_from,  // "YYYY-MM-DD HH:MM:SS"
  date_to: date_to,      // "YYYY-MM-DD HH:MM:SS"
  used_marketing_value: 0
}; 


  const result = await SaveVendorStetmment(payload);
if (!result.success) {
  alert(result.message);
} else {
   setToast({ open: true, message: 'Rozliczono koszty marketingu', severity: 'success' });
  setApproved(true);
  onSave?.(v.vendor, payload);
}
    } catch (err) {
      console.error(err);
         setToast({ open: true, message: 'Rozliczono koszty marketingu.', severity: 'error' });

      //alert('Nie udało się zapisać danych.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      key={v.vendor}
      className={`p-3 border border-gray-200 rounded flex flex-col sm:flex-row justify-between items-start sm:items-start gap-4 ${
        allSettled ? 'bg-green-50 border-green-300' : ''
      }`}
    >
      {/* LEWA STRONA */}
      <div className="flex-1 min-w-0">
        <div className="font-medium break-words">
          {v.vendor} - {v.SumaLicencjiKwota} zł
        </div>
        <div className="text-sm text-gray-500">
          {v.count} Akcje • Od kwoty: {v.bonusBase}zł
        </div>

        {/* 🔹 Edycja marketingu i faktury */}
        <div className="mt-2 flex flex-wrap items-center gap-2 items-end">

          {approved ?(<div><span className="text-xs text-gray-500">Marketing: </span><span className="font-medium">{marketingCost} PLN</span></div>):(
 <Input
            type="number"
            label="Koszt marketingu"
            className="border rounded px-2 py-1 text-sm w-28"
            value={marketingCost}
            disabled={approved}
            onChange={(e) => setMarketingCost(e.target.value)}
          />
)}
         

{approved ?(<div><span className="text-xs text-gray-500">Faktura: </span><span className="font-medium">{invoiceNumber === "" ? "BRAK" : invoiceNumber}</span></div>):!isCurrentMonth?(


 
 <Input
            label="Numer faktury"
            type="text"
            placeholder="Numer faktury"
            className="border rounded px-2 py-1 text-sm w-36"
            value={invoiceNumber}
            disabled={approved}
            onChange={(e) => setInvoiceNumber(e.target.value)}
          />
):('')}
         


          {!approved && !isCurrentMonth && (
            
            <Button
              size="small"
              onClick={handleSave}
              disabled={saving || Number(marketingCost) < 0}
            >
              {saving ? 'Zapisywanie...' : 'Zatwierdź'}
            </Button>
          )}
          {approved && <Chip color="success" size="small" label="Zatwierdzono" />}
        </div>
      </div>

      {/* PRAWA STRONA */}
      <div className="flex flex-col items-end gap-1 text-right w-full sm:w-auto">
  {/* 🔹 Górny wiersz: kwota + napis w jednej linii */}
  <div className="flex flex-row items-baseline gap-1 w-full sm:w-auto justify-end">
    <div className="font-medium">{v.ProwizjaDlaVendora} zł</div>
    <div className="text-xs text-gray-500">suma dla dostawcy</div>
  </div>

  {/* 🔹 Dolny wiersz: komunikaty / przyciski */}
  <div className="flex items-center gap-2 text-sm flex-wrap justify-end max-w-full sm:max-w-[200px]">
    {isCurrentMonth ? (
      <span className="text-xs text-gray-500 break-words">
        Nie można rozliczyć trwającego miesiąca
      </span>
    ) : approved ? (
      allSettled ? (
        <Chip color="success" size="small" label="Rozliczono" />
      ) : (
        <Button variant="outlined" onClick={() => openSettleForVendor(v)}>
          Rozlicz
        </Button>
      )
    ) : (
      <span className="text-xs text-red-500 break-words">
        Zatwierdź dane rozlizeniowe
      </span>
    )}
  </div>
</div>
      <Snackbar open={toast.open} message={toast.message} onClose={() => setToast({ ...toast, open: false })} severity={toast.severity} />

    </div>
  );
}
